<div class="email-item">
    {{email.name}}
    <i class="fas fa-times-circle icon-delete" *ngIf="showDeleteButton && email.id" matTooltip="Eliminar correo"
        aria-label="Eliminar correo electrónico" (click)="onDeleteEmail()"></i>
</div>